import { render } from "./deviceDetail.vue?vue&type=template&id=56291372&scoped=true"
import script from "./deviceDetail.vue?vue&type=script&lang=js"
export * from "./deviceDetail.vue?vue&type=script&lang=js"

import "./deviceDetail.vue?vue&type=style&index=0&id=56291372&scoped=true&lang=css"
import "./deviceDetail.vue?vue&type=style&index=1&id=56291372&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56291372"]])

export default __exports__